import request from '../request.js';

// eslint-disable-next-line import/prefer-default-export
export const getActualDates = () => request({
  url: 'poster/active-date',
  type: 'GET',
  addCSRFToken: true,
  data: {},
  needOverlay: false,
});
